module.exports = __webpack_public_path__ + "static/media/uncheck.7c00c6bc.svg";